<template>
    <div class="w-dyn-list">
        <div  v-if="products.length > 0"  class="w-dyn-items w-row">
            <div  v-for="product in products"  :key="product.name" class="collection-item-3 w-dyn-item w-col w-col-3">
                <div  class="product-category-card coming-soon">
                    <img :src="product.image" :alt="product.name" class="product-image">
                    <div class="product-divider"></div>
                    <div class="category-title">{{product.name}}</div>
                    <div class="text-block-19">{{product.available}}</div>
                    <router-link v-bind:to="'/contact-us'" class="offer-mats w-button">Offer Support</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "ComingSoon",
        data() {
            return {
                products: [
                    {
                        name: 'Testing Kits',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/testing_kits.png',
                        available: 'Coming Mid-May'
                    },
                    {
                        name: 'Ventilators',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/ventilators.png',
                        available: 'Coming Mid-May'
                    },
                    {
                        name: 'Thermometers',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/thermometers.png',
                        available: 'Coming soon...'
                    },
                    {
                        name: 'Eye Protection',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/eye_protection.png',
                        available: 'Coming soon...'
                    },
                    {
                        name: 'Gowns and Coveralls',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/gowns.png',
                        available: 'Coming soon...'
                    },
                    {
                        name: 'Nitrile Gloves / Vinyl Gloves',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/gloves.png',
                        available: 'Coming soon...'
                    },
                    {
                        name: 'Disposable Surgical Masks',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/surgical_masks.png',
                        available: 'Coming soon...'
                    },
                    {
                        name: 'Disposable N95 Masks',
                        image: 'https://bulky-dev-covid.s3.us-east-2.amazonaws.com/n95.png',
                        available: 'Coming soon...'
                    }

                ]
            }
        },
        components: {
        }
    }
</script>

<style scoped>

</style>
